module.exports = "https://static.im-cdn.com/mjc/storefront/Sakra/static/media/Star.c4776806.svg";